export const css = {
    root: '_2CgfkhO1',
    content: '_3h9U8Tzl',
    bottom: '_3QrOMQz1',
    top: '_2Pytlz5I',
    left: '_2wSvrKUK',
    right: 'CHglFImF',
    ' _key': 'afcpe-theme/afcpe/dojo/tooltip'
};
export default css;
